import React from "react";
import SiteVisit from "./SiteVisit";
import { connect } from "react-redux";
import withHOC from "../../HOC/HOC";
import { bindActionCreators } from "redux";
import { loanUpdateAction, setSiteVisitAction, updateInvalidFormFieldAction } from "../CreateLoan/CreateLoanAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import { Row } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
class SiteVisitContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            toShowToast: false,
            successToastMessage: "",
            level: "",
        }
    }
    scrollToTop = () => {
        window.scrollTo(0, 0);
      };
    callAPI = (siteVisitDetails, callback) => {
        this.scrollToTop();
        this.props.setSiteVisitAction(siteVisitDetails);
        const requestData = {
            minimartId: this.props.singleMiniMart.id,
            loanApplicationId: this.props.applyLoanConfig.loanApplicationId,
            siteVisit: siteVisitDetails
        };
        this.props.showLoadingModal();
        loanUpdateAction(requestData, (response) => {
            if(response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    toShowToast: true,
                    successToastMessage: Strings("loanFormUpdatedSuccessfully"),
                    level: "success",
                },()=>{
                    setTimeout(() => {
                        this.props.closeLoadingModal();
                        callback("");
                        this.props.updateInvalidFormFieldAction("SITE_VISIT");
                        this.props.handleNext();
                    }, 1000);
                });
            } else {
                this.scrollToTop();
                callback(response.error?.message);
                this.props.updateInvalidFormFieldAction("SITE_VISIT");
                this.props.closeLoadingModal();
            }
            
        })
    }
    render() {
        
        return (
            <Row>   
                {this.state.toShowToast && (
                    <UserNotification
                        key={this.state.successToastMessage}
                        userNotificationObj={{
                            message: this.state.successToastMessage,
                            level: this.state.level,
                        }}
                    />
                )}
                <SiteVisit
                    siteVisitList={this.props.siteVisitList}
                    goNext={this.props.handleNext}
                    goBack={this.props.handleBack}
                    loanApplicationDetails={this.props.loanApplicationDetails}
                    siteVisitDetails={this.props.siteVisitDetails}
                    callAPI={this.callAPI}
                    siteVisit={this.props.siteVisit}
                    disableTextField={this.props.disableTextField}
                    errorMessage={this.state.errorMessage}
                    invalidFormField={this.props.invalidFormField}
                    showLoadingModalState={this.props.showLoadingModalState}
                    scrollToTop={this.scrollToTop}
                />
            </Row>
        )
    }

}
const mapStateToProps = (state) => ({
    singleMiniMart: state.minimartListReducer.singleMiniMart,
    loanApplicationId: state.loanDetailsReducer.loanApplicationId,
    allLoanDetails: state.loanDetailsReducer.allLoanDetails,
    financialInfoDetails: state.loanDetailsReducer.financialInfoDetails,
    siteVisitDetails: state.loanDetailsReducer.siteVisitDetails,
    siteVisit: state.loanDetailsReducer.siteVisit,
    applyLoanConfig: state.loanDetailsReducer.applyLoanConfig,
    invalidFormField: state.loanDetailsReducer.invalidFormField,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { setSiteVisitAction, updateInvalidFormFieldAction },
        dispatch
    );
};
const SiteVisitContainerWrapper = withHOC(SiteVisitContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SiteVisitContainerWrapper);